import React from 'react';
import { Link } from 'react-router-dom';

const PURPLE_GRADIENT = 'linear-gradient(145deg,#7c3aed,#5b21b6)';
const headingStyle = { color: '#5b21b6', fontWeight: 700 };
const ctaStyle = {
    background: PURPLE_GRADIENT,
    border: 'none',
    color: '#fff',
    fontWeight: 700,
    boxShadow: '0 3px 0 #4c1d95, 0 4px 10px rgba(124,58,237,0.4)',
};

const AboutPage = () => {
    const websiteName = 'Kobra Prep';

    return (
        <div className="container-fluid py-5" style={{ background: '#f5f3ff', minHeight: '100vh' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="card shadow-sm" style={{ border: '1px solid #ede9fe', borderRadius: '0.9rem', overflow: 'hidden' }}>
                            {/* Themed header banner */}
                            <div style={{ background: PURPLE_GRADIENT, color: '#fff', padding: '2rem 1.5rem', textAlign: 'center' }}>
                                <h1 className="fs-2 fw-bold mb-2">About Kobra Prep — Your Path to Exam Success</h1>
                                <p className="mb-0" style={{ opacity: 0.92, maxWidth: 760, margin: '0 auto' }}>
                                    {websiteName} is your dedicated companion for competitive exam preparation in Bangladesh —
                                    SSC, HSC, BCS, Bank, and university admissions. We turn scattered study into focused,
                                    measurable progress so you walk into the exam hall confident.
                                </p>
                            </div>

                            <div className="card-body p-4 p-md-5">
                                <div className="d-flex justify-content-center gap-3 mb-2">
                                    <Link to="/" className="btn btn-lg rounded-pill px-4 py-2" style={ctaStyle}>
                                        Start Your Free Test Today!
                                    </Link>
                                </div>

                                <hr className="my-5" style={{ borderColor: '#ddd6fe', opacity: 1 }} />

                                <h2 className="fs-4 mb-4" style={headingStyle}>Why Choose Kobra Prep?</h2>
                                <p className="text-secondary mb-4">
                                    We built the platform around <strong>efficiency, relevance, and results</strong>. Here's what sets us apart:
                                </p>
                                <ul className="list-group list-group-flush mb-5">
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold" style={headingStyle}>Comprehensive Question Bank</h5>
                                        <p className="text-secondary mb-0">
                                            Thousands of curated multiple-choice questions across subjects, topics, and difficulty
                                            levels — mapped to the exams that matter in Bangladesh.
                                        </p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold" style={headingStyle}>Daily Quick Tests &amp; Free Practice</h5>
                                        <p className="text-secondary mb-0">
                                            Take a timed 15-question test or practice freely at your own pace — no signup needed to start.
                                            Reveal answers and explanations exactly when you're ready.
                                        </p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold" style={headingStyle}>Smart Performance Tracking</h5>
                                        <p className="text-secondary mb-0">
                                            A per-subject report card shows exactly where you're weak, so you can jump straight into
                                            practicing the subjects that will move your score the most.
                                        </p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold" style={headingStyle}>Detailed Explanations</h5>
                                        <p className="text-secondary mb-0">
                                            Every question comes with a clear explanation, so you understand the <em>why</em> behind
                                            each answer and learn from every mistake.
                                        </p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold" style={headingStyle}>Learn Anywhere</h5>
                                        <p className="text-secondary mb-0">
                                            Study on any device, whenever it fits your schedule. Favorite tricky questions and revisit
                                            them anytime.
                                        </p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold" style={headingStyle}>Always Up to Date</h5>
                                        <p className="text-secondary mb-0">
                                            Exam patterns evolve, and so do we. Our question bank is reviewed and updated to reflect the
                                            latest syllabus and standards.
                                        </p>
                                    </li>
                                </ul>

                                <hr className="my-5" style={{ borderColor: '#ddd6fe', opacity: 1 }} />

                                <h2 className="fs-4 mb-4" style={headingStyle}>How It Works</h2>
                                <ol className="list-group list-group-numbered mb-5">
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold mb-0" style={headingStyle}>Choose your level</h5>
                                        <p className="text-secondary mb-0">Pick the level relevant to your target exam (SSC, HSC, BCS, Bank, Varsity).</p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold mb-0" style={headingStyle}>Take tests or practice</h5>
                                        <p className="text-secondary mb-0">Attempt a quick test or practice a set of random questions — filtered by subject if you like.</p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold mb-0" style={headingStyle}>Review &amp; learn</h5>
                                        <p className="text-secondary mb-0">Check your report card and read the explanation for every question.</p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold mb-0" style={headingStyle}>Track your progress</h5>
                                        <p className="text-secondary mb-0">Watch your accuracy climb and target the subjects that need work next.</p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold mb-0" style={headingStyle}>Achieve your goal</h5>
                                        <p className="text-secondary mb-0">Build confidence, improve your scores, and get exam-ready.</p>
                                    </li>
                                </ol>

                                <hr className="my-5" style={{ borderColor: '#ddd6fe', opacity: 1 }} />

                                <h2 className="fs-4 mb-4" style={headingStyle}>Who Is It For?</h2>
                                <p className="text-secondary mb-3">Kobra Prep is ideal for:</p>
                                <ul className="list-group list-group-flush mb-5">
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold" style={headingStyle}>Students (SSC / HSC / Varsity)</h5>
                                        <p className="text-secondary mb-0">Prepare for board and admission exams with focused practice.</p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold" style={headingStyle}>BCS &amp; Government Job Aspirants</h5>
                                        <p className="text-secondary mb-0">Drill the subjects and question patterns that appear in public-sector exams.</p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold" style={headingStyle}>Bank Job Candidates</h5>
                                        <p className="text-secondary mb-0">Sharpen speed and accuracy for competitive bank recruitment tests.</p>
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <h5 className="fw-semibold" style={headingStyle}>Anyone Who Loves to Learn</h5>
                                        <p className="text-secondary mb-0">Strengthen your knowledge through practical, bite-sized practice.</p>
                                    </li>
                                </ul>

                                <hr className="my-5" style={{ borderColor: '#ddd6fe', opacity: 1 }} />

                                <h2 className="fs-4 mb-3 text-center" style={headingStyle}>Our Commitment to You</h2>
                                <p className="text-center text-secondary mb-4" style={{ maxWidth: 760, margin: '0 auto' }}>
                                    At {websiteName}, your success is our priority. We continuously improve our platform and content to
                                    meet the evolving needs of learners across Bangladesh.
                                </p>

                                <div className="d-flex justify-content-center gap-3">
                                    <Link to="/" className="btn btn-lg rounded-pill px-4 py-2" style={ctaStyle}>
                                        Start Your Free Test Today!
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;
